import { datadogLogs } from "@datadog/browser-logs";

import useImmediateEffect from "@/hooks/useImmediateEffect";
import {
  getLoggingSampleSessionRate,
  isLoggingEnabled,
  versionForDatadog,
} from "@/monitoring/utils";
import getApplicationEnvironment from "@/utils/getApplicationEnvironment";

import useDatadogUserProperties from "../useDatadogUserProperties";

const BrowserLogging = () => {
  useImmediateEffect(() => {
    if (!globalThis.window) return;
    const { environment } = getApplicationEnvironment();
    if (isLoggingEnabled()) {
      // Comprehensive list of init parameters https://docs.datadoghq.com/logs/log_collection/javascript/#initialization-parameters
      datadogLogs.init({
        clientToken: process.env["NEXT_PUBLIC_DATADOG_TOKEN"] ?? "",
        env: environment,
        site: "datadoghq.com",
        version: versionForDatadog,
        service: "lyceum",
        // Forwards console.error logs, uncaught exceptions and network errors to Datadog
        forwardErrorsToLogs: true,
        /*
         * This may need to change to avoid running out of our DD budget.
         * https://docs.datadoghq.com/logs/
         * Forwards logs from console.*. Options include: "All" or an array of "log" "debug" "info" "warn" "error"
         */
        forwardConsoleLogs: ["error"],
        // percentage of sessions to track and send logs for
        sessionSampleRate: getLoggingSampleSessionRate(),
      });
    }
  }, []);

  const datadogUserProperties = useDatadogUserProperties();

  useImmediateEffect(() => {
    if (!globalThis.window) return;
    datadogLogs.setUser(datadogUserProperties);
  }, [datadogUserProperties]);

  return null;
};

export default BrowserLogging;
